import { ViewModel } from '../../view-model';
import { CONFIG } from '../../../core/config';
import { ModelVisualCategoryCalibrationList } from '../model-category-calibration/model-visual-category-calibration';
import { RiskMatrixBand } from './risk-matrix-band';
import { RiskMatrixConsequenceVector } from './risk-matrix-consequence-vector';
import { RiskMatrixProbabilityVector } from './risk-matrix-probability-vector';

export class RiskMatrix implements ViewModel {
  readonly friendlyTypeNameSingular = 'Risk Matrix';
  readonly apiRoute = CONFIG.apiRoutes.riskMatrices;

  riskMatrixId: string;
  name: string;
  description: string;
  consequencePosition: RiskMatrixConsequencePosition;
  isDefault: boolean;
  createdBy: string;
  creationDate: string;
  lastModifiedBy: string;
  lastModifiedDate: string;
  isCofAscending: boolean = true;
  isPofAscending: boolean = true;
  stepUpCategoryId: string;
  defaultCalibrationsId: string;
  defaultCalibrations: ModelVisualCategoryCalibrationList = new ModelVisualCategoryCalibrationList();

  consequenceVectors: RiskMatrixConsequenceVector[] = [];
  probabilityVectors: RiskMatrixProbabilityVector[] = [];
  riskBands: RiskMatrixBand[] = [];

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.riskMatrixId = data.riskMatrixId;
    this.name = data.name;
    this.description = data.description;
    this.consequencePosition = data.consequencePosition;
    this.isDefault = data.isDefault;
    this.createdBy = data.createdBy;
    this.creationDate = data.creationDate;
    this.lastModifiedBy = data.lastModifiedBy;
    this.lastModifiedDate = data.lastModifiedDate;
    this.isPofAscending = data.isPofAscending;
    this.isCofAscending = data.isCofAscending;
    this.stepUpCategoryId = data.stepUpCategoryId;
    this.defaultCalibrationsId = data.defaultCalibrationsId;

    if (data.consequenceVectors) {
      data.consequenceVectors.forEach(vector => {
        const newVector = new RiskMatrixConsequenceVector();
        newVector.loadFromJson(vector);
        this.consequenceVectors.push(newVector);
      });
    }

    if (data.probabilityVectors) {
      data.probabilityVectors.forEach(vector => {
        const newVector = new RiskMatrixProbabilityVector();
        newVector.loadFromJson(vector);
        this.probabilityVectors.push(newVector);
      });
    }

    if (data.riskBands) {
      data.riskBands.forEach(band => {
        const newBand = new RiskMatrixBand();
        newBand.loadFromJson(band);
        this.riskBands.push(newBand);
      });
    }

    if (data.defaultCalibrations) {
      const newCalibrations = new ModelVisualCategoryCalibrationList();
      newCalibrations.loadFromJson(data.defaultCalibrations);
      this.defaultCalibrations = newCalibrations;
    }
  }
}

export enum RiskMatrixConsequencePosition {
  columns = 0,
  rows = 1,
}
